
$(document).ready(function(){

    $('#customer_birthday').datetextentry({
        field_order : 'MDY',
        separator   : '/',
        show_tooltips : false,
        field_width_day   : 10,
        field_width_month : 10,
        field_width_year  : 10
    });

    function createCustomer(Fname,Lname,Bdate,Email,Phonenumbr,Password,acceptMarketing,rgstrBtnThis)
    {
        rgstrBtnThis.attr('disabled','disabled');
        rgstrBtnThis.attr('aria-busy','true');
        rgstrBtnThis.find(".loader-button__loader").removeAttr('hidden');
        if(Phonenumbr != '')
        {
          var phoneNum = "+1"+ Phonenumbr;
        }
        else
        {
          var phoneNum = "";
        }
        var inputFields = {};
        inputFields.firstName = Fname;
        inputFields.lastName = Lname;
        if(Email)
        {
            inputFields.email = Email;
        }
        if(Phonenumbr)
        {
            inputFields.phone = "+1"+ Phonenumbr;
        } 
        inputFields.password = Password;
        inputFields.acceptsMarketing = acceptMarketing;
        $.ajax({
		  url: "https://create-customer.fame.workers.dev/",
		  method: "POST",
          dataType: 'json',
		  data:{'first_name':Fname,'last_name':Lname,'email':Email,'phone':phoneNum,'verified_email':true,'password':Password,'password_confirmation':Password,'note':Bdate,'accepts_marketing':acceptMarketing,'send_email_welcome':false}, 
		  success: function(html){
            rgstrBtnThis.removeAttr('aria-busy');
            $(".error").text('');
            if(html.errors)
            {
              $(".error").text('');
              if(html.errors.email)
              {
                $(".emailIdErr").text(html.errors.email[0]);                
              }
              if(html.errors.phone)
              {
                $(".phoneErr").text(html.errors.phone[0]);                
              }
              if(html.errors.password)
              {
                $(".passwrdErr").text(html.errors.password[0]);                
              }
              rgstrBtnThis.removeAttr('disabled');
            }
            else if(html.customer.id)
            {
                $("#customer_first_name").val('');
                $("#customer_last_name").val('');
                $("#customer_birthday").val('');
                $(".jq-dte-inner input").val('');
                $("#customer_email").val('');
                $("#customer_phone").val('');
                $("#customer_password").val('');
                $(".account__block-item").html('');
                $(".account__block-item").html('<div class="green"><svg xmlns="http://www.w3.org/2000/svg" class="check-svg active" viewBox="0 0 24 24"><g stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><circle class="success-circle-outline" cx="12" cy="12" r="11.5"/><circle class="success-circle-fill" cx="12" cy="12" r="11.5"/><polyline class="success-tick" points="17,8.5 9.5,15.5 7,13"/></g></svg></div><p class="registerThankMessage">Thank You '+Fname+' for becoming a Fame VIP member!</p>');
                setTimeout(function(){
                    location.reload();
                },5000);
            }
		  }
		});      
    }

    var phoneInput = document.getElementById('customer_phone');
    phoneInput.addEventListener('input', function (e) {
        var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });

    function validateRegisterForm(pagename,rgstrBtnThis)
    {
        var Fname = Lname = Bdate = Email = Phonenumbr = acceptMarketing = Password = '';
        var isErr = isEmailEmpty= isEmailErr = 0;
        
        Fname = $("#customer_first_name").val();
        Lname = $("#customer_last_name").val();
        Bdate = $("#customer_birthday").val();
        Email = $("#customer_email").val();
        Phonenumbr = $("#customer_phone").val().replace(/[^A-Z0-9]/ig, "");
        Password = $("#customer_password").val();
        acceptMarketing = $('#acceptsMarketingChckbx').is(':checked');

        if(Fname.length < 1)
        {
            $(".fNameErr").text('');
            $(".fNameErr").text('First Name is Required');
            isErr = 1;
        }
        else
        {
            $(".fNameErr").text('');
        }

        if(Lname.length < 1)
        {
            $(".LNameErr").text('');
            $(".LNameErr").text('Last Name is Required');
            isErr = 1;
        }
        else
        {
            $(".LNameErr").text('');
        }

        if(Bdate.length < 1)
        {
            $(".bdayErr").text('');
            $(".bdayErr").text('Birth Date is Required');
            isErr = 1;
        }
        else
        {
            $(".bdayErr").text('');
        }

        if(Email.length < 1)
        {
            $(".emailIdErr").text('');
            $(".emailIdErr").text('Email is Required');
            isErr = 1;
        }
        else
        {
            var emailRegEx = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/; 
            if (emailRegEx.test(Email)) {  
                $(".emailIdErr").text('');
            }
            else
            {    
                $(".emailIdErr").text('');  
                $(".emailIdErr").text('Enter a valid email'); 
                isErr = 1; 
            }
        }      
        
        if(Phonenumbr.length < 1)
        {
            if(pagename != 'kioskRegistration')
            {
                $(".phoneErr").text('');
                $(".phoneErr").text('Phone Number is Required');
                isErr = 1;
            }
            else
            {
                $(".phoneErr").text('');
            }
        }
        else
        {
            $(".phoneErr").text('');
        }

        if(Password.length < 1)
        {
            $(".passwrdErr").text('');
            $(".passwrdErr").text('Password is Required');
            isErr = 1;
        }
        else
        {
            $(".passwrdErr").text('');
        }
        if(isErr == 0)
        {
            createCustomer(Fname,Lname,Bdate,Email,Phonenumbr,Password,acceptMarketing,rgstrBtnThis);
        }
    }
    
    $(document).on("click","#kioskRegisterBtn",function(){
        var kioskBtnThis = $(this);
        var pageNm = 'kioskRegistration';
        validateRegisterForm(pageNm,kioskBtnThis);
    });

    $(document).on("click","#customRegisterBtn",function(){
        var custmrBtnThis = $(this);
        var pageNm = 'DefaultRegistration';
        validateRegisterForm(pageNm,custmrBtnThis);
    });
});